import { useState } from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function EditModal({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [name, setName] = useState(data.name || "");
  const [forfaitFactor, setForfaitFactor] = useState(data.forfaitFactor || 100);
  const [programmeType, setProgrammeType] = useState(data.programmeType || 0);
  const [budgetFTE, setBudgetFTE] = useState(data.budgetFTE || 0);

  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      if (data.ID) {
        await api.updateProgramme(data.ID, {
          name,
          forfaitFactor,
          programmeType,
          budgetFTE,
        });
      } else {
        await api.createProgramme({ name, forfaitFactor, programmeType, budgetFTE });
      }

      //api.createSnapshot();
      toastService.send({ title: "Success", message: "Opleiding is opgeslagen" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "An error occured", message: error });
    }
  };
  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Opleiding {data.ID ? "bewerken" : "aanmaken"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Naam</Form.Label>
                <Form.Control type="text" required onChange={e => setName(e.target.value)} value={name} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Type opleiding</Form.Label>
                <Form.Select onChange={e => setProgrammeType(parseInt(e.target.value, 10))} value={programmeType}>
                  <option value={0}>Bachelor</option>
                  <option value={1}>Graduaat</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Forfait: 100% = ... uur</Form.Label>
                <Form.Control type="number" required onChange={e => setForfaitFactor(parseFloat(e.target.value))} value={forfaitFactor} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Budget VTE</Form.Label>
                <Form.Control
                  type="number"
                  required
                  step="0.1"
                  onChange={e => setBudgetFTE(parseFloat(e.target.value))}
                  value={budgetFTE}
                />
              </Form.Group>

              <Button variant="primary" type="submit" disabled={snapshot}>
                {data.ID ? (
                  <span>
                    <i className="far fa-edit" />
                    &nbsp;Bewerk
                  </span>
                ) : (
                  <span>
                    <i className="far fa-plus" />
                    &nbsp;Aanmaken{" "}
                  </span>
                )}
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;
